import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, configuration, nextConfiguration }) =>
    present(
      repository
        .updateProjectListingConfiguration(
          planzone,
          configuration,
          nextConfiguration,
        )
        .then(() => ({ configuration: nextConfiguration, planzone }))
        .catch(() =>
          Promise.reject({ planzone, configuration, nextConfiguration }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
